module.exports = __webpack_public_path__ + "img/scratch_fr@2x.26345abf.png";